import React, { useState, useEffect } from 'react';
import { Dialog } from '@tencent/spaui';
import moment from 'moment';
import { isLeadsRole } from '../../utils/routes';
import { judgeIsFromTMC } from '../../utils';

// 弹窗是否允许在tmc嵌入的情况下显示
const DISABLE_IN_TMC = true;

// 第几波弹窗
const STAGE = {
  value: 3,
  start: '2022/08/25',
  end: '2022/09/10',
  roles: ['超级管理员', '管理员', '免登录'],
};

export const Util = {
  _stage: STAGE,
  getCacheKey(type) {
    if (!type) throw new Error('no type input');
    const userId = window.pageProps.operationUserId;
    if (!userId) throw new Error('user id not found');
    return `_cache_new_feature_${type}_${userId}`;
  },
  getStage() {
    const cacheKey = this.getCacheKey('confirmed');
    const cache = window.localStorage.getItem(cacheKey);
    if (!cache) return 0;
    return parseInt(cache);
  },
  confirmStage() {
    const cacheKey = this.getCacheKey('confirmed');
    window.localStorage.setItem(cacheKey, this._stage.value);
  },
  isCanceledInToday() {
    let cache = window.localStorage.getItem(this.getCacheKey('cancel'));
    if (!cache) return false;
    cache = parseInt(cache);
    const now = new Date();
    if (cache < moment(now).startOf('day').valueOf()) return false;
    return cache < moment(now).endOf('day').valueOf();
  },
  cancel() {
    window.localStorage.setItem(
      this.getCacheKey('cancel'),
      new Date().valueOf(),
    );
  },
  /**
   * 是否在需要弹窗的周期内
   */
  isInStage() {
    const now = new Date().valueOf();
    let { start, end } = this._stage
    const { value } = this._stage;
    start = moment(new Date(this._stage.start)).startOf('day').valueOf();
    end = moment(new Date(this._stage.end)).endOf('day').valueOf();
    if (now < start) return false;
    if (now > end) return false;
    // 不一致表示没看过，给他看
    return value !== this.getStage();
  },
  getDefaultShowDialog() {
    if (DISABLE_IN_TMC && judgeIsFromTMC()) return false;
    if (!isLeadsRole(this._stage.roles)) return false;
    if (this.isCanceledInToday()) return false;
    return this.isInStage();
  },
};

const Body = () => {
  const src = 'https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/images/new_feature_intro_04.png';
  return (
    <div style={{ width: 590, height: 423, paddingBottom: 20 }}>
      <img className="png-body" src={src} alt="img" style={{ width: '100%' }} />
    </div>
  );
};

const NewFeature = () => {
  const [show, setShow] = useState(Util.getDefaultShowDialog());

  const handleCancel = () => {
    Util.cancel();
    setShow(false);
  };

  const handleConfirm = () => {
    Util.confirmStage();
    setShow(false);
    window.open('https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/wechat_work_auth_helper.pdf');
  };

  useEffect(() => {
    window.c = () => {
      window.localStorage.removeItem(Util.getCacheKey('cancel'));
      window.localStorage.removeItem(Util.getCacheKey('confirmed'));
    };
  }, []);

  return (
    <Dialog
      show={show}
      type="normal"
      title={null}
      cancelLabel="下次吧"
      submitLabel="了解详情"
      style={{ width: 592 }}
      onClose={handleCancel}
      onCancel={handleCancel}
      onSubmit={handleConfirm}
      className="new-feature"
    >
      <Body />
    </Dialog>
  );
};

export default NewFeature;
